<template>
  <div>
    <div class="d-flex justify-content-end">
      <div class="d-flex justify-content-between button-group">
        <img src="@/assets/images/common-icons/icon_clear.png" @click="cleanFilters"
             :title="$t('buttons.common.clear_filters')">
        <img src="@/assets/images/common-icons/icon_search.svg" @click="search"
             :title="$t('buttons.common.search')">
      </div>
    </div>
    <div class="search-form">
      <div class="search-form__filters">
        <b-row>
          <b-col>
            <label>{{$t('labels.common.smart_search')}}
              <b-badge size="sm" variant="primary" id="smartSearchPopover">i</b-badge>
              <b-popover target="smartSearchPopover" triggers="hover focus">
                <template slot="title">Smart Search Instruction</template>
                Filter format:<strong> [T] [W] [L] [Wood] [Quality] [Humidity] </strong>,where<br>
                <strong>[T]</strong> – nominal order item thickness, should be single value <br>
                <strong>[W]</strong> – nominal order item width, should be single value<br>
                <strong>[L]</strong> – nominal order item length, should be single value<br>
                Order of sizes is mandatory –<strong> T, W, L;</strong>
                order of other parameters is optional. All matching is case insensitive.
                <strong>Examples:</strong>
                <em>45 95 2400 egle i-iii 12%
                  50 100 3600 18%
                  45 95 I-III</em>
              </b-popover>
            </label>
            <input class="form-control" v-model="searchData.description" @keyup.enter="search"
                   placeholder="">
          </b-col>
          <b-col>
            <label>{{$t('labels.common.supplier')}}</label>
            <multiselect v-model="searchData.suppliers" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="suppliers" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.purchase_orders.PO_status')}}</label>
            <multiselect v-model="searchData.status" :max-height="200"
                         placeholder=""
                         :options="status"
                         :taggable="true" :close-on-select="true"></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.common.quality')}}</label>
            <multiselect v-model="searchData.quality" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="qualities_list" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.agent')}}</label>
            <multiselect v-model="searchData.agent" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="agents" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.delivery_date')}}</label>
            <range-date-picker v-model="searchData.delivery_term" range lang="en"
                               placeholder=""
                               range-separator="/" :first-day-of-week="1"></range-date-picker>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="d-flex justify-content-between toggle-container" @click="showCollapse = !showCollapse"
         :aria-expanded="showCollapse ? 'true' : 'false'"
         aria-controls="collapse">
      <h3>
        {{$t('labels.common.advanced_search')}}
      </h3>
      <div class="icons-wrapper">
        <icon name="angle-down" class="angle" v-if="showCollapse"></icon>
        <icon name="angle-right" class="angle" v-else></icon>
      </div>
    </div>
    <b-collapse id="collapse" v-model="showCollapse">
      <div class="search-form">
        <div class="search-form__filters">
          <b-row>
            <b-col cols="1">
              <label>{{$t('labels.contracts.contract_number')}}</label>
            </b-col>
            <b-col cols="3">
              <multiselect v-model="searchData.contracts" :max-height="200"
                           placeholder="" label="contract_nr" track-by="id"
                           :options="contractsList" :multiple="true"
                           :taggable="true" :close-on-select="false"></multiselect>
            </b-col>
            <b-col cols="1">
              <label>{{$t('labels.common.wood')}}</label>
            </b-col>
            <b-col cols="3">
              <multiselect v-model="searchData.wood" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="wood" :multiple="false"
                           :taggable="true" :close-on-select="true"></multiselect>
            </b-col>
            <b-col cols="1">
              <label>{{$t('labels.common.measure_type')}}</label>
            </b-col>
            <b-col cols="3">
              <multiselect v-model="searchData.measure_type" :max-height="200"
                           placeholder=""
                           :options="measure_types" :multiple="true"
                           :taggable="true" :close-on-select="false"></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="1">
              <label>{{$t('labels.purchase_orders.PO_number')}}</label>
            </b-col>
            <b-col cols="3">
              <input class="form-control" v-model="searchData.order_nr" @keyup.enter="search"
                     placeholder="">
            </b-col>
            <b-col cols="1">
              <label>{{$t('labels.common.humidity')}}</label>
            </b-col>
            <b-col cols="3">
              <multiselect v-model="searchData.humidity" :max-height="200"
                           placeholder=""
                           :options="humidity_list" :multiple="true"
                           :taggable="true" :close-on-select="false"></multiselect>
            </b-col>
            <b-col cols="1">
              <label>{{$t('labels.purchase_orders.profile')}}</label>
            </b-col>
            <b-col cols="3">
              <multiselect v-model="searchData.profile" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="profiles" :multiple="true"
                           :taggable="true" :close-on-select="false"></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="1">
              <label>{{$t('labels.common.currency')}}</label>
            </b-col>
            <b-col cols="3">
              <multiselect v-model="searchData.currency" :max-height="200"
                           placeholder="" label="code" track-by="code"
                           :options="currencies" :multiple="true"
                           :taggable="true" :close-on-select="false"></multiselect>
            </b-col>
            <b-col cols="1">
              <label>{{$t('labels.common.transport')}}</label>
            </b-col>
            <b-col cols="3">
              <multiselect v-model="searchData.delivery_methods" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="delivery_methods" :multiple="true"
                           :taggable="true" :close-on-select="false"></multiselect>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-collapse>
    <div>
      <b-row>
        <b-col cols="4">
          <input class="form-control"
                 v-model="searchData.quick_search"
                 placeholder=""
                 @input="setQuickFilter">
        </b-col>
        <b-col cols="4" offset="4" class="vertical-center-container d-flex justify-content-end">
          <save-columns-btn :grid="gridOptions" :grid-name="gridName" class="margin-left-5"></save-columns-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <ag-grid-vue class="ag-theme-balham" :gridOptions="gridOptions" :style="gridHeight"
                       :columnDefs="orderItemsColumns" :rowData="orderItems" :pinnedBottomRowData="pinnedRowData"
                       :postProcessPopup="postProcessPopup">
          </ag-grid-vue>
        </b-col>
      </b-row>
      <b-row class="pagination__wrapper">
        <b-col cols="5">
          <div class="pagination-info">{{countOfViewOrderItems}} {{$t('common_content.of')}} {{orderItemsCount}}
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import {
    mapGetters,
    mapState
  } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import RangeDatePicker from 'vue2-datepicker';
  import SaveColumnsBtn from '@/components/common/SaveColumnsBtn';
  import moment from 'moment';
  import {
    cleanFilters,
    saveFilters,
    setFilters,
    checkSavedFilterData,
    getArrayByProperty,
  } from '@/helpers/commonHelpers';
  import { gridMixins } from '@/mixins';
  import { DATE_FORMAT } from '@/constants';

  export default {
    name: 'PurchaseOrderItemsList',
    mixins: [gridMixins],
    components: {
      Multiselect,
      RangeDatePicker,
      SaveColumnsBtn,
      'ag-grid-vue': AgGridVue
    },
    data() {
      return {
        showCollapse: false,
        status: ['active', 'completed'],
        searchData: {
          description: '',
          wood: '',
          quality: [],
          status: 'active',
          humidity: [],
          delivery_term: '',
          contracts: [],
          suppliers: [],
          delivery_methods: [],
          order_nr: '',
          currency: [],
          measure_type: [],
          agent: [],
          profile: [],
          quick_search: ''
        }
      }
    },
    watch: {
      'searchData.quick_search': {
        deep: true,
        handler () {
          this.setQuickFilter()
        }
      }
    },
    methods: {
      search() {
        const searchObject = {
          ...this.searchData,
          wood: this.searchData.wood ? this.searchData.wood.id : '',
          quality: getArrayByProperty(this.searchData.quality, 'id').toString(),
          delivery_term_between_after: this.searchData.delivery_term && this.searchData.delivery_term[0] ? moment(this.searchData.delivery_term[0]).format(DATE_FORMAT) : '',
          delivery_term_between_before: this.searchData.delivery_term && this.searchData.delivery_term[1] ? moment(this.searchData.delivery_term[1]).format(DATE_FORMAT) : '',
          contracts: getArrayByProperty(this.searchData.contracts, 'id').toString(),
          suppliers: getArrayByProperty(this.searchData.suppliers, 'id').toString(),
          delivery_methods: getArrayByProperty(this.searchData.delivery_methods, 'id').toString(),
          currencies: getArrayByProperty(this.searchData.currency, 'id').toString(),
          measure_type: this.searchData.measure_type && this.searchData.measure_type.toString(),
          humidity: this.searchData.humidity.toString(),
          agent: getArrayByProperty(this.searchData.agent, 'id').toString(),
          profile: getArrayByProperty(this.searchData.profile, 'id').toString()
        };
        this.$store.dispatch('purchaseOrderItems/loadOrderItems', searchObject);
        saveFilters('purchaseOrderItems', this.searchData)
      },
      cleanFilters() {
        cleanFilters(this.searchData);
      },
      setQuickFilter() {
        this.gridOptions.api.setQuickFilter(this.searchData.quick_search);
      },
      clearData() {
        this.$store.commit('purchaseOrderItems/setItems', []);
      }
    },
    beforeMount() {
      this.$store.cache.dispatch('woodware/getWood');
      this.$store.cache.dispatch('woodware/getQualitiesList');
      this.$store.cache.dispatch('woodware/getDeliveryMethods');
      this.$store.cache.dispatch('generic/getCurrencies');
      this.$store.cache.dispatch('woodware/getProfiles');
      this.$store.dispatch('woodware/loadHumidityList');
      this.$store.dispatch('partners/getSuppliers');
      this.$store.dispatch('partners/getSaleAgents');
      this.$store.dispatch('contracts/loadContractsList');
      if (checkSavedFilterData('purchaseOrderItems')) {
        this.searchData = setFilters('purchaseOrderItems');
        this.search();
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.clearData();
      });
    },
    computed: {
      ...mapState('purchaseOrderItems', ['gridName']),
      ...mapState('woodware', ['humidity_list', 'wood', 'qualities_list', 'delivery_methods', 'measure_types', 'profiles']),
      ...mapState('partners', ['suppliers', 'agents']),
      ...mapState('generic', ['currencies']),
      ...mapGetters('purchaseOrderItems', {
        gridOptions: 'gridOptions'
      }),
      ...mapState('purchaseOrderItems', ['pinnedRowData', 'orderItemsCount', 'orderItemsColumns', 'orderItems']),
      ...mapState('contracts', ['contractsList']),
      countOfViewOrderItems() {
        return this.orderItems.length;
      },
      gridHeight() {
        if (window.innerHeight > 1024) {
          return this.showCollapse ? {height: 'calc(100vh - 500px)'} : {height: 'calc(100vh - 360px)'};
        } else {
          return this.showCollapse ? {height: '400px'} : {height: 'calc(100vh - 360px)'};
        }

      }
    }
  }
</script>

<style scoped>

  .grid {
    height: 550px;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/modules/purchases/order-items/PurchaseOrderItemsList.vue